var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BoxWrap", [
        _c(
          "div",
          { attrs: { slot: "header-info" }, slot: "header-info" },
          [
            [
              _c("div", { staticClass: "title-wrap" }, [
                _c("span", { staticClass: "panel-title" }, [
                  _vm._v(_vm._s(_vm.$t("sfe.route.bailianreport")) + " "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-size": "12px",
                      "padding-left": "20px",
                      color: "red",
                    },
                  },
                  [
                    _vm._v(
                      "由于该表涉及多表查询，查询表中数据量大，为保证搜索顺畅，搜索时请加上客户创建日期或反馈日期进行组合查询"
                    ),
                  ]
                ),
              ]),
            ],
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "FPermission",
                rawName: "v-FPermission",
                value: { pageName: _vm.pageName, list: ["LIST"] },
                expression: "{ pageName, list: ['LIST'] }",
              },
            ],
            staticClass: "action-container",
          },
          [
            _c(
              "el-form",
              {
                staticClass: "searchForm",
                attrs: {
                  model: _vm.searchVal,
                  size: "small",
                  inline: "",
                  "label-position": "top",
                },
              },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("sfe.bailianReport.input.baiLianStoreName"),
                    },
                  },
                  [
                    _c("FormInput", {
                      attrs: { val: _vm.searchVal.baiLianStoreName },
                      on: {
                        "update:val": function ($event) {
                          return _vm.$set(
                            _vm.searchVal,
                            "baiLianStoreName",
                            $event
                          )
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("sfe.bailianReport.input.storeBrand"),
                    },
                  },
                  [
                    _c("FormInput", {
                      attrs: { val: _vm.searchVal.storeBrand },
                      on: {
                        "update:val": function ($event) {
                          return _vm.$set(_vm.searchVal, "storeBrand", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("sfe.bailianReport.input.empNo") } },
                  [
                    _c("FormInput", {
                      attrs: { val: _vm.searchVal.empNo },
                      on: {
                        "update:val": function ($event) {
                          return _vm.$set(_vm.searchVal, "empNo", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: _vm.$t("sfe.bailianReport.input.empName") },
                  },
                  [
                    _c("FormInput", {
                      attrs: { val: _vm.searchVal.empName },
                      on: {
                        "update:val": function ($event) {
                          return _vm.$set(_vm.searchVal, "empName", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t(
                        "sfe.bailianReport.input.provinceCityDistrict"
                      ),
                    },
                  },
                  [
                    _c("el-cascader", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: _vm.$t(
                          "DAStoreList.form.cascaderPlaceholder"
                        ),
                        options: _vm.regionOptions,
                        "collapse-tags": "",
                        clearable: "",
                        props: {
                          multiple: true,
                          checkStrictly: false,
                          value: "value",
                        },
                      },
                      on: {
                        clear: _vm.pcdClearEvent,
                        change: _vm.pcdChangeEvent,
                      },
                      model: {
                        value: _vm.region,
                        callback: function ($$v) {
                          _vm.region = $$v
                        },
                        expression: "region",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "flexRow",
                    attrs: { label: _vm.$t("sfe.bailianReport.input.date") },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "startDay" } },
                      [
                        _c("FormDatePicker", {
                          attrs: {
                            val: _vm.searchVal.startTime,
                            valueformat: "yyyy-MM-dd",
                            "picker-options": _vm.startPickerOptions,
                          },
                          on: {
                            "update:val": function ($event) {
                              return _vm.$set(
                                _vm.searchVal,
                                "startTime",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "picker-line" }, [_vm._v("-")]),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "endDay" } },
                      [
                        _c("FormDatePicker", {
                          attrs: {
                            val: _vm.searchVal.endTime,
                            valueformat: "yyyy-MM-dd",
                            "picker-options": _vm.endPickerOptions,
                          },
                          on: {
                            "update:val": function ($event) {
                              return _vm.$set(_vm.searchVal, "endTime", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "flexRow",
                    attrs: {
                      label: _vm.$t("sfe.bailianReport.input.feedbackDate"),
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "startDay" } },
                      [
                        _c("FormDatePicker", {
                          attrs: {
                            val: _vm.searchVal.feedbackStartTime,
                            valueformat: "yyyy-MM-dd",
                            "picker-options": _vm.feedbackStartPickerOptions,
                          },
                          on: {
                            "update:val": function ($event) {
                              return _vm.$set(
                                _vm.searchVal,
                                "feedbackStartTime",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "picker-line" }, [_vm._v("-")]),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "endDay" } },
                      [
                        _c("FormDatePicker", {
                          attrs: {
                            val: _vm.searchVal.feedbackEndTime,
                            valueformat: "yyyy-MM-dd",
                            "picker-options": _vm.feedbackEndPickerOptions,
                          },
                          on: {
                            "update:val": function ($event) {
                              return _vm.$set(
                                _vm.searchVal,
                                "feedbackEndTime",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { attrs: { slot: "footer-right" }, slot: "footer-right" },
          [
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "FPermission",
                    rawName: "v-FPermission",
                    value: { pageName: _vm.pageName, list: ["LIST"] },
                    expression: "{ pageName, list: ['LIST'] }",
                  },
                ],
                attrs: { size: "small", icon: "el-icon-refresh" },
                on: { click: _vm.resetData },
              },
              [_vm._v(_vm._s(_vm.$t("common.reset")) + "\n      ")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "FPermission",
                    rawName: "v-FPermission",
                    value: { pageName: _vm.pageName, list: ["LIST"] },
                    expression: "{ pageName, list: ['LIST'] }",
                  },
                ],
                staticClass: "t-search-btn",
                attrs: { size: "small", icon: "el-icon-search" },
                on: { click: _vm.searchData },
              },
              [_vm._v(_vm._s(_vm.$t("common.search")) + "\n      ")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "BoxWrap",
        {
          staticClass: "main-table-container",
          attrs: { title: _vm.$t("common.list") },
        },
        [
          _c("div", { attrs: { slot: "header-right" }, slot: "header-right" }, [
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "FPermission",
                        rawName: "v-FPermission",
                        value: { pageName: _vm.pageName, list: ["EXPORT"] },
                        expression: "{ pageName, list: ['EXPORT'] }",
                      },
                    ],
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.downloadExcel },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("common.export") +
                            _vm.$t("sfe.bailianReport.exportFileName")
                        ) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "FPermission",
                        rawName: "v-FPermission",
                        value: { pageName: _vm.pageName, list: ["EXPORT"] },
                        expression: "{ pageName, list: ['EXPORT'] }",
                      },
                    ],
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.downloadExcel2 },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("common.export") +
                            _vm.$t("sfe.bailianReport.exportSumFileName")
                        ) +
                        "\n        "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                "highlight-current-row": "",
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "baiLianStoreId",
                  label: _vm.$t("sfe.bailianReport.baiLianStoreId"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "baiLianStoreName",
                  label: _vm.$t("sfe.bailianReport.baiLianStoreName"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "baiLianAddress",
                  label: _vm.$t("sfe.bailianReport.baiLianAddress"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "baiLianProvince",
                  label: _vm.$t("sfe.bailianReport.baiLianProvince"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "baiLianCity",
                  label: _vm.$t("sfe.bailianReport.baiLianCity"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "baiLianDistrict",
                  label: _vm.$t("sfe.bailianReport.baiLianDistrict"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "baiLianPhone",
                  label: _vm.$t("sfe.bailianReport.baiLianPhone"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "businessStatus",
                  label: _vm.$t("sfe.bailianReport.businessStatus"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "score",
                  label: _vm.$t("sfe.bailianReport.score"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "storeBrand",
                  label: _vm.$t("sfe.bailianReport.storeBrand"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "monthTireSalesAvg",
                  label: _vm.$t("sfe.bailianReport.monthTireSalesAvg"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "empNo",
                  label: _vm.$t("sfe.bailianReport.empNo"),
                  "min-width": "200",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "empName",
                  label: _vm.$t("sfe.bailianReport.empName"),
                  "min-width": "200",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "region",
                  label: _vm.$t("sfe.bailianReport.region"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "feedbackContent",
                  label: _vm.$t("sfe.bailianReport.feedbackContent"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "feedbackDay",
                  label: _vm.$t("sfe.bailianReport.feedbackDay"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "relatedStoreId",
                  label: _vm.$t("sfe.bailianReport.relatedStoreId"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "handleRelatedStoreId",
                  label: _vm.$t("sfe.bailianReport.handleRelatedStoreId"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rtlSapId",
                  label: _vm.$t("sfe.bailianReport.rtlSapId"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rtlFullName",
                  label: _vm.$t("sfe.bailianReport.rtlFullName"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rtlAddress",
                  label: _vm.$t("sfe.bailianReport.rtlAddress"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: _vm.$t("sfe.bailianReport.createTime"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "latestSubmitDatetime",
                  label: _vm.$t("sfe.bailianReport.latestSubmitDatetime"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "latestDetailOne",
                  label: _vm.$t("sfe.bailianReport.latestDetailOne"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "latestDetailTwo",
                  label: _vm.$t("sfe.bailianReport.latestDetailTwo"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "evaluateRate",
                  label: _vm.$t("sfe.bailianReport.evaluateRate"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "acceptTerms",
                  label: _vm.$t("sfe.bailianReport.acceptTerms"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "urgentDeliveryTime",
                  label: _vm.$t("sfe.bailianReport.urgentDeliveryTime"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "regularDeliveryTime",
                  label: _vm.$t("sfe.bailianReport.regularDeliveryTime"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "willingToRtmOrder",
                  label: _vm.$t("sfe.bailianReport.willingToRtmOrder"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "goodContent",
                  label: _vm.$t("sfe.bailianReport.goodContent"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "badContent",
                  label: _vm.$t("sfe.bailianReport.badContent"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "otherContent",
                  label: _vm.$t("sfe.bailianReport.otherContent"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total > 0",
              },
            ],
            attrs: { total: _vm.total, page: _vm.currPage, limit: _vm.limit },
            on: {
              "update:page": function ($event) {
                _vm.currPage = $event
              },
              "update:limit": function ($event) {
                _vm.limit = $event
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }